// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--b6ZUG","link":"link--FWpNu","icon":"icon--XKLDL","small":"small--oCFZS","medium":"medium--FaLRY","large":"large--PExqr","fadeSlideUp":"fadeSlideUp--Fgj0f"};